<div class="file-wrapper">
  <span class="file-name" [class.error]="error" [tooltip]="error">{{ fileName }}</span>
  <progressbar *ngIf="!completed && progress !== -1" [value]="progress" [type]="error ? 'danger' : 'info'" [animate]="true">{{ progress | number: '1.0-0' }}%</progressbar>
</div>
<i *ngIf="deletable" id="delete-button" i-bs name="x-square" width="15" height="15" class="icon-btn" (click)="$event.stopPropagation(); onDelete.emit()"></i>
